<div class="wrapper-loader" *ngIf="isLoading"></div>
<div #container class="route-cont {{animation}} animated" *ngIf="options">
  <app-ds-header
    [widgetConfig]="headerWidgets$ | async"
    [isTransparent]="true"
    (clickAction)="goBack()">
  </app-ds-header>
  <div class="body" #bodycontainer>
    <div *ngFor="let sector of options">
      <div class="trip-header">
        <hr *ngIf="isReturnHeader(sector)" class="divider" />
        <span>{{ tripTypeHeader(sector) | transloco }}</span>
        <p class="type-date">{{sector.DepartureDate | date: 'EEEE, d MMM yyyy' | dateFormat }}</p>
        <p class="city-codes">{{sector.DepartureAirport}} - {{sector.ArrivalAirport}}</p>
      </div>
      <app-flight-detail
        [flightClass]="flightClass"
        [flightKeys]="getItineraryFlightKeys(null, sector)"
        [provider]="provider"
        [sector]="sector"
        [isLoadingCabinDetail]="isLoadingFlightCabinDetail$ | async"
        [cabinAmenities]="cabinAmenities$ | async"
        [isMobile]="isMobile$ | async"
        [isLoggedIn]="isLoggedIn$ | async"
        [isLoadingFlightCabin]="isLoadingFlightCabin$ | async"
        [flightCabinSelected]="flightCabinSelected$ | async"
        [isInternational]="isInternational"
        (openCabinDetail)="openCabinDetail($event)">
      </app-flight-detail>
    </div>
  </div>
  <div class="btn-selection">
    <app-fixed-surface
      [boxShadow]="true"
      [surface]="backgroudSurface">
      <app-ds-button
        [isLoading]="isLoading"
        [labels]="{ ButtonLabel: 'FLIGHT_RESULTS_MODULE.ITINERARY_LIST_SECTION.IS_MOBILE.SELECT_FLIGHTS_DETAIL' | transloco: { price: price } }"
        (clickEvent)="selectFlights()">
      </app-ds-button>
    </app-fixed-surface>
  </div>
</div>
